import ApiRequest from '../../utils/ApiRequest';
import { EnrollmentPackageId, PlanTypeId } from '../../types/api/primaryKeys/PrimaryKey';
import { AvailablePlansDetail } from '../../types/api/plans/AvailablePlansDetail';

/** Returns information about the available plans for the specified package and plan type. */
export async function getAvailablePlansForPlanType(packageId: EnrollmentPackageId, planTypeId: PlanTypeId) {
    const result = await ApiRequest.get<AvailablePlansDetail>(`packages/${packageId}/availablepolicies/${planTypeId}`);
    return result;
}